/* assets/theme.js */

document.addEventListener('DOMContentLoaded', () => {
  // Mobile navigation toggle
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileNav.classList.toggle('is-active');
      document.body.classList.toggle('overflow-hidden');
    });
  }

  // Sticky header on scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    });
  }

  // Announcement bar ticker
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    const messages = announcementBar.querySelectorAll('.announcement-message');
    if (messages.length > 1) {
      let currentMsg = 0;
      setInterval(() => {
        messages[currentMsg].style.display = 'none';
        currentMsg = (currentMsg + 1) % messages.length;
        messages[currentMsg].style.display = 'block';
      }, 3000);
    }
  }

  // Variant selector change handler
  const variantRadios = document.querySelectorAll('.product-option input[type="radio"]');
  if (variantRadios.length > 0) {
    variantRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        // Find selected options
        const selectedOptions = Array.from(document.querySelectorAll('.product-option input[type="radio"]:checked')).map(el => el.value);
        // This is a simplified handler. In a real theme, we would map these to the variant JSON
        // and update price, ID, and URL accordingly.
        console.log('Variant changed:', selectedOptions);
      });
    });
  }

  // Quantity selector +/- buttons
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  quantitySelectors.forEach(selector => {
    const btnMinus = selector.querySelector('.minus');
    const btnPlus = selector.querySelector('.plus');
    const input = selector.querySelector('input[type="number"]');

    if (btnMinus && btnPlus && input) {
      btnMinus.addEventListener('click', () => {
        let val = parseInt(input.value);
        if (val > 1) {
          input.value = val - 1;
        }
      });
      btnPlus.addEventListener('click', () => {
        let val = parseInt(input.value);
        input.value = val + 1;
      });
    }
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });

  // Simple cart drawer open/close
  const cartIcon = document.querySelector('.header-cart-icon');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');

  const openCart = (e) => {
    if(e) e.preventDefault();
    if(cartDrawer) {
      cartDrawer.classList.add('is-open');
      if(cartOverlay) cartOverlay.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    }
  };

  const closeCart = () => {
    if(cartDrawer) {
      cartDrawer.classList.remove('is-open');
      if(cartOverlay) cartOverlay.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    }
  };

  if(cartIcon && cartDrawer) {
    cartIcon.addEventListener('click', openCart);
  }
  if(cartClose) {
    cartClose.addEventListener('click', closeCart);
  }
  if(cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

});
